'use client'

import useFacilitiesWithIcons from '@/hooks/useFacilitiesWithIcons';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export default function FacilsRenderer({ facilities, noBackground }: { facilities: any, noBackground?: boolean }) {
    const facils = useFacilitiesWithIcons(facilities)
    return !noBackground ? (
        facils.slice(0, 2).map(item => (
            <span
                className='flex rounded-md items-center gap-1 px-2 py-1 text-white text-xs font-normal
                                            bg-black/50 w-fit line-clamp-1'
                key={item.iconName}>
                <span className='text-xs justify-self-center'>
                    {item.iconElement ?
                        item.iconElement
                        : <FontAwesomeIcon className='' icon={faCheckCircle} />}
                </span>
                <p className='line-clamp-1'>
                    {item.iconName}
                </p>
            </span>))
    ) : facils?.slice(0, 5).map((item, index) => (
        <div
          key={index}
          className={`
            ${index < 2 ? 'hidden lg:grid' : ''}
             rounded-m capitalize grid grid-cols-[16px,_1fr] line-clamp-1 text-xs 
             items-center gap-2  font-medium text-gray-700`}
        >
          <span className='text-xs justify-self-center'>
            {item.iconElement ?
              item.iconElement ||
              <FontAwesomeIcon className='text-neutral-500' icon={faCheckCircle} />
              : <FontAwesomeIcon className='text-neutral-500' icon={faCheckCircle} />}
          </span>
          <div className='line-clamp-1'>
            <span>{item.iconName}</span>
          </div>
        </div>
      ));
}